import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

let state = {
  children: []
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
